import axiosInstance from "./axiosInstance";

export const ClusterService = {
  getClustersByOrganization: async (organizationId: string) => {
    const response =  await axiosInstance.get(
      `/api/v1/organizations/${organizationId}/clusters`
    );
    return response.data;
  },
};
